import { render, staticRenderFns } from "./splitter-banner.vue?vue&type=template&id=2777ac92&"
import script from "./splitter-banner.vue?vue&type=script&lang=js&"
export * from "./splitter-banner.vue?vue&type=script&lang=js&"
import style0 from "./splitter-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
